/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as ServerDefs from "./defs.defs.js";

const $nsid = "place.stream.server.listWebhooks";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"limit":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer({"minimum":1,"maximum":100}), 50)),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"active":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"event":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.enum(["chat","livestream","follow","mention","stream.received"]))});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"webhooks":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<ServerDefs.Webhook>((() => ServerDefs.webhook) as any), ),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** List webhooks for the authenticated user. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["InvalidCursor"]);

export { main };

export const $lxm = $nsid;
